// Nodes modules
import './modules/@tc';
import 'classlist-polyfill';
import 'object-fit-polyfill';
//import animateScrollTo from 'animated-scroll-to';
//import * as Swiper from 'swiper/dist/js/swiper.js';
//import * as Stickyfill from 'stickyfilljs';
import barba from '@barba/core';
var body = document.body;

function bodyVisible() {
    body.style.opacity = 1;
}

function bodyVisibleTimeout() {
    setTimeout(bodyVisible, 2500);
}

bodyVisibleTimeout();


/**
 * Accordion
 * Compatible Drupal + transitions AJAX
 */
function initAccordion(scope = document) {
    const accordions = scope.querySelectorAll('.js-accordion');

    accordions.forEach(accordion => {
        const toggle = accordion.querySelector('.js-accordion-toggle');
        const content = accordion.querySelector('.js-accordion-content');

        if (!toggle || !content) return;

        // Anti double init
        if (accordion.dataset.accordionInit === 'true') return;
        accordion.dataset.accordionInit = 'true';

        toggle.addEventListener('click', () => {

            const container = accordion.parentElement;

            container.querySelectorAll('.js-accordion.is-open').forEach(open => {
                if (open !== accordion) {
                    open.classList.remove('is-open');
                    const openContent = open.querySelector('.js-accordion-content');
                    if (openContent) openContent.style.maxHeight = null;
                }
            });

            accordion.classList.toggle('is-open');

            // ⚡ Attente du rendu pour scrollHeight correct
            requestAnimationFrame(() => {
                content.style.maxHeight = accordion.classList.contains('is-open')
                    ? content.scrollHeight + 'px'
                    : null;
            });
        });
    });

    // Ouvre le premier accordion automatiquement
    const firstAccordion = scope.querySelector('.js-accordion');
    if (firstAccordion && !firstAccordion.classList.contains('is-open')) {
        const content = firstAccordion.querySelector('.js-accordion-content');
        firstAccordion.classList.add('is-open');
        if (content) {
            requestAnimationFrame(() => {
                content.style.maxHeight = content.scrollHeight + 'px';
            });
        }
    }
}



/* =========================
   INIT
========================= */

// chargement normal
document.addEventListener('DOMContentLoaded', () => {
    initAccordion();
});


window.addEventListener('load', function(){
    /* General */
    var body = document.body;
    body.style.opacity = 1;

    /* Language Switch */
    function langSwitch() {
        let falseSwitcher = document.querySelector('.language-switcher-btn');
        let falseSwitchFR = falseSwitcher.querySelector(".fr-btn");
        let falseSwitchEN = falseSwitcher.querySelector(".en-btn");

        let trueSwitcher = document.getElementById('block-languageswitcher');
        let trueSwitchFR = trueSwitcher.querySelector("a[hreflang=fr]");
        let trueSwitchEN = trueSwitcher.querySelector("a[hreflang=en]");

        //trueSwitchFR.style.color = "red";
        //console.log(trueSwitchFR);

        if (window.location.href.indexOf("fr") > -1) {
            falseSwitchFR.classList.add('actif-lang');
            falseSwitchEN.classList.remove('actif-lang');
        } else {
            falseSwitchEN.classList.add('actif-lang');
            falseSwitchFR.classList.remove('actif-lang');
        }

        falseSwitchFR.onclick = function() {
            trueSwitchFR.click();
            //console.log('boom');

            //location.reload();
            //return false;
        }

        falseSwitchEN.onclick = function() {
            trueSwitchEN.click();
            //console.log('bam');

            //location.reload();
            //return false;
        }
    }

    langSwitch();

    let mm = gsap.matchMedia(); /* Responsive GSAP test function */
    var allLink = document.querySelectorAll("a");
    var blackShade = document.querySelector(".black-shade");
    const bgTransition = document.querySelector('.bg-transition');
    const firstContainer = document.querySelector('.main-content');
    var canvas = document.querySelector(".canvas");

    if (typeof(canvas) != 'undefined' && canvas != null) {       
        var ctx = canvas.getContext('2d');
        var canvasContainer = document.querySelector(".canvas-container");
        var canvasContainerHeight = canvasContainer.offsetHeight;
    }

    var menuBtn = document.getElementById("menu-btn");
    var menuBox = document.querySelector('.responsive-nav');
    var menuBoxLink = menuBox.querySelectorAll('.nav li');
    var menuBoxSecondLink = menuBox.querySelectorAll('.about-nav p, .about-nav li');
    var menuBoxFooter = menuBox.querySelector('.nav-footer'); 

    // Button animation
    function animedBtn () {
        Array.from(document.querySelectorAll('.btn-rounded')).forEach((roundedButton) => {
            roundedButton.innerHTML = '<span>' + roundedButton.innerHTML+ '</span>';

            let roundedButtonFSpan = roundedButton.querySelector('span');
            let roundedButtonSSpan = roundedButtonFSpan.cloneNode(true);

            roundedButton.appendChild(roundedButtonSSpan);

            roundedButton.innerHTML = '<span>' + roundedButton.innerHTML+ '</span>';
            
        });
    }

    animedBtn();

    // Anchor scroll (training 2026)
    document.querySelectorAll('.js-scroll').forEach(link => {
        link.addEventListener('click', function (e) {
          e.preventDefault(); // empêche le comportement par défaut
      
          const target = document.querySelector(this.getAttribute('href'));
          if (target) {
            // Offset si header sticky (optionnel)
            const offset = 100; // ajuster selon la hauteur de ton header
            const y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        });
    });

    // Accordion programme (training 2026)
    /*
    function initAccordion(scope = document) {
        // Attache le click listener
        scope.querySelectorAll('.js-accordion-toggle').forEach(toggle => {
            toggle.addEventListener('click', () => {
                const parent = toggle.closest('.js-accordion');
    
                scope.querySelectorAll('.js-accordion.is-open').forEach(open => {
                    if (open !== parent) {
                        open.classList.remove('is-open');
                        const content = open.querySelector('.js-accordion-content');
                        if (content) content.style.maxHeight = null;
                    }
                });
    
                parent.classList.toggle('is-open');
                const content = parent.querySelector('.js-accordion-content');
                if (content) {
                    content.style.maxHeight = parent.classList.contains('is-open')
                        ? content.scrollHeight + 'px'
                        : null;
                }
            });
        });
    
        // Ouvre le premier accordion automatiquement
        const firstAccordion = scope.querySelector('.js-accordion');
        if (firstAccordion) {
            firstAccordion.classList.add('is-open');
            const content = firstAccordion.querySelector('.js-accordion-content');
            if (content) content.style.maxHeight = content.scrollHeight + 'px';
        }
    }

    initAccordion();
    */

    // Scroll to form after confirmation (training 2026)
    const confirmation = document.querySelector('.formation-wrapper .webform-confirmation');
    const target = document.getElementById('training-register');

    if (confirmation && target) {
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
    

    // Change body of training (training 2026)
    if (document.querySelector('.formation-wrapper')) {
        document.body.classList.add('training-body');
    }
      

    // Responsive nav
    function toggleMainNav() {
        body.classList.toggle("menu-open");
    }

    function toggleBodyFixed() { 
        body.classList.add("body-fixed");
        menuBtn.style.pointerEvents = "auto";
        //menuBtn.style.marginRight = scrollBarWidth + "px";
    }

    function timeout_init() {
        setTimeout(toggleBodyFixed, 250);
    }

    function menuResponsiveOpenUpdate() {
        menuBox.style.zIndex = "9990";
    }

    function menuResponsiveCloseUpdate() {
        menuBox.style.zIndex = "-1";
    }

    let responsiveMenuTimeline = gsap.timeline({
        //onStart: () => menuResponsiveOpenUpdate(),
        //onReverseComplete: () => menuResponsiveCloseUpdate(),
    });
    
    mm.add("(max-width: 991px)", () => {
        responsiveMenuTimeline.fromTo(menuBox, {
            opacity:0,
        },
        {
            duration: 0.2,
            opacity: 1,
        }, "-=.2");

        responsiveMenuTimeline.fromTo(menuBoxLink, {
            opacity:0,
            y:20
        },
        {
            duration: 0.5,
            opacity: 1,
            y:0,
            stagger: .075,
        }, "-=.2");

        responsiveMenuTimeline.fromTo(menuBoxSecondLink, {
            opacity:0,
            y:20
        },
        {
            duration: 0.5,
            opacity: 1,
            y:0,
            stagger: .075,
        }, "-=.2");

        responsiveMenuTimeline.fromTo(menuBoxFooter, {
            opacity:0,
        },
        {
            duration: 0.3,
            opacity: 1,
        }, "-=.3");
    });

    responsiveMenuTimeline.pause();

    if (typeof(menuBtn) != 'undefined' && menuBtn != null) {
        menuBtn.onclick = function() {
            toggleMainNav();
            menuBtn.style.pointerEvents = "none";

            if (body.classList.contains('menu-open')) {
                responsiveMenuTimeline.play();
            } else {
                responsiveMenuTimeline.reverse();
            }

            
            if (body.classList.contains('body-fixed')) {
                body.classList.remove("body-fixed");
                menuBtn.style.pointerEvents = "auto";
                //menuBtn.style.marginRight = "0px";
            } else {
                timeout_init();
            }
        };
    }

    /* Canvas */
    mm.add("(min-width: 1200px)", () => {
        if (typeof(canvas) != 'undefined' && canvas != null) {       

            canvas.width = window.innerWidth;
            canvas.height = canvasContainerHeight;

            var stars = []; // Array that contains the stars
            var FPS = 60; // Frames per second
            var x = 100; // Number of stars

            // Push stars to array
            for (var i = 0; i < x; i++) {
                stars.push({
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height,
                    radius: Math.random() * 1 + 1,
                    vx: Math.floor(Math.random() * 50) - 25,
                    vy: Math.floor(Math.random() * 50) - 25
                });
            }

            // Draw the scene
            function draw() {
                ctx.clearRect(0,0,canvas.width,canvas.height);
                
                ctx.globalCompositeOperation = "lighter";
                
                for (var i = 0, x = stars.length; i < x; i++) {
                    var s = stars[i];
                
                    ctx.fillStyle = "#e3e3e3";
                    ctx.beginPath();
                    ctx.arc(s.x, s.y, s.radius, 0, 2 * Math.PI);
                    ctx.fill();
                    ctx.fillStyle = 'black';
                    ctx.stroke();
                }
                
                ctx.beginPath();
                for (var i = 0, x = stars.length; i < x; i++) {
                    var starI = stars[i];
                    ctx.moveTo(starI.x,starI.y); 
                    for (var j = 0, x = stars.length; j < x; j++) {
                        var starII = stars[j];
                        if(distance(starI, starII) < 150) {
                            //ctx.globalAlpha = (1 / 150 * distance(starI, starII).toFixed(1));
                            ctx.lineTo(starII.x,starII.y); 
                        }
                    }
                }
                ctx.lineWidth = 0.05;
                ctx.strokeStyle = '#b1b1b1';
                ctx.stroke();
            }

            function distance( point1, point2 ){
                var xs = 0;
                var ys = 0;
                
                xs = point2.x - point1.x;
                xs = xs * xs;
                
                ys = point2.y - point1.y;
                ys = ys * ys;
                
                return Math.sqrt( xs + ys );
            }

            // Update star locations
            function update() {
                for (var i = 0, x = stars.length; i < x; i++) {
                    var s = stars[i];
                
                    s.x += s.vx / FPS;
                    s.y += s.vy / FPS;
                    
                    if (s.x < 0 || s.x > canvas.width) s.vx = -s.vx;
                    if (s.y < 0 || s.y > canvas.height) s.vy = -s.vy;
                }
            }

            // Update and draw
            function tick() {
                draw();
                update();
                requestAnimationFrame(tick);
            }

            tick();
        }
    });

    /* Big Menu */
    var serviceBtn = document.querySelector(".nav .nav-item-collapsed");
    var header = document.getElementById('main-header'); 
    var menuBox = document.querySelector('.services-bigmenu');   
    var menuBoxLink = menuBox.querySelectorAll('.services-bigmenu .service-card'); 

    /* Scroll bar calc */
    mm.add("(max-width: 991px)", () => {
        function scrollbarCalc() {
            var scrollerBox = document.querySelector('.scroller');
            var scrollbarWidth = scrollerBox.offsetWidth - scrollerBox.clientWidth;
            //menuBtn.style.marginRight = scrollbarWidth + "px";

            header.style.width = scrollerBox.offsetWidth - scrollbarWidth + "px";
        } 
        
        scrollbarCalc();

        onresize = (event) => {
            scrollbarCalc();
        };
    });
    

    function menuOpenUpdate() {
        menuBox.style.display = "block";
        blackShade.style.zIndex = "998";
    }

    function menuCloseUpdate() {
        menuBox.style.display = "none";
        blackShade.style.zIndex = "-1";
        menuBox.style.display = "none";
    }

    let menuTimeline = gsap.timeline({
        onStart: () => menuOpenUpdate(),
        onReverseComplete: () => menuCloseUpdate(),
    });

    menuTimeline.fromTo(blackShade, {
        opacity:0,
    },
    {
        duration: .3,
        opacity: 1,
    });

    menuTimeline.fromTo(header, {
        backgroundColor: "#ffffff",
    },
    {
        duration: .3,
        backgroundColor: "#fafafa",
    }, "-=.2");
    
    menuTimeline.fromTo(menuBoxLink, {
        opacity:0,
        y:20
    },
    {
        duration: 0.3,
        opacity: 1,
        y:0,
        stagger: .075,
    });

    menuTimeline.pause();

    function toggleBigMenu() {
        body.classList.toggle("bigmenu-open");
    }

    serviceBtn.onclick = function() {
        toggleBigMenu();

        if (body.classList.contains('bigmenu-open')) {
            menuTimeline.play();
        } else {
            menuTimeline.reverse(-1);
            menuCloseUpdate();
        }
    };

    blackShade.onclick = function() {
        body.classList.remove("bigmenu-open");
        menuTimeline.reverse(-1);
        //blackShade.style.zIndex = "-1";
        menuCloseUpdate();
    };

    mm.add("(max-width: 991px)", () => {
        body.classList.remove("bigmenu-open");
        menuTimeline.reverse(-1);
        menuCloseUpdate();
        

        gsap.to(menuBoxLink, {
            opacity:0,
            y:20,
            stagger: .075,
        });
    });

    allLink.forEach(function(el) {
        el.addEventListener('click', function(){
            body.classList.remove("bigmenu-open");
            //blackShade.style.zIndex = "-1";

            setTimeout(()=> {
                menuCloseUpdate();
                menuTimeline.reverse(-1);
             }
             ,500);
        });
    });

    /* Sub-services accordion */
    function subservicesAccordion() {
        var acc = document.getElementsByClassName("accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function() {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
                } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
                } 
            });
        }
    }
    subservicesAccordion();


    /* Nav Fix */
    function headerShowHide() {
        /* Header Show/Hide */
         
        ScrollTrigger.create({
            start: "top 300px",
            //end: 99999,
            //markers: true,

            toggleClass: { targets: 'body', className: 'is-tiny' },
        });
        
    }
    headerShowHide();

    /* First appear */
    gsap.fromTo(firstContainer, {
        opacity: 0,
        y:20,
        //ease: 'power4.inOut'
    },
    {  
        y:0,
        opacity: 1, 
        duration: .5,
        //delay: .5,
    });

    /* For Ajax */
    function testForceReload() {
        var links = document.querySelectorAll('a[href]');
        var cbk = function(e) {
            if(e.currentTarget.href === window.location.href) {
                e.preventDefault();
                e.stopPropagation();
            }
        };
    
        for(var i = 0; i < links.length; i++) {
            links[i].addEventListener('click', cbk);
        }
    }
    testForceReload();

    /* Update nav active */
    function updateMainMenu(mainnavUrl) {
        const mainnavActive = document.querySelector('.col-right a.is-active');
        const mainnavTrail = document.querySelector('.col-right li.nav-item-collapsed');
        const fixResponsive = document.querySelector('.responsive-fix');

        if (mainnavActive !== null) {
            mainnavActive.classList.remove('is-active');
        }

        if (window.location.href.indexOf("services") > -1) {
            //console.log("your url contains the name franky");
            mainnavTrail.classList.add('nav-item-active-trail');
        } else {
            //console.log("your url NOT the name franky");
            mainnavTrail.classList.remove('nav-item-active-trail');
        }

        if (window.location.href.indexOf("propos") > -1) {
            //console.log("your url contains the name franky");
            fixResponsive.classList.add('is-active');
        } else {
            //console.log("your url NOT the name franky");
            fixResponsive.classList.remove('is-active');
        }
   
        const mainnavLinks = Array.from(document.querySelectorAll('.col-right a'));
        mainnavLinks.push("http://localhost:9000");
        //mainnavLinks.push("http://localhost:9000/rgpd");
                
        const mainnavIndex = mainnavLinks.map(link => link.href).findIndex((href) => {
            return mainnavUrl.indexOf(href) !== -1;
        });
        
        if (mainnavIndex !== -1) {
            mainnavLinks[mainnavIndex].classList.add('is-active');
        }
    }

    function updateBigMenu(bigmenuUrl) {
        const bigmenuActive = document.querySelector('.services-bigmenu a.is-active');
        
        if (bigmenuActive !== null) {
            bigmenuActive.classList.remove('is-active');
        }
                
        const bigmenuLinks = Array.from(document.querySelectorAll('.services-bigmenu a'));
        bigmenuLinks.push("http://localhost:9000");
                
        const bigmenuIndex = bigmenuLinks.map(link => link.href).findIndex((href) => {
            return bigmenuUrl.indexOf(href) !== -1;
        });
        
        if (bigmenuIndex !== -1) {
            bigmenuLinks[bigmenuIndex].classList.add('is-active');
        }
    }

    /* Test link from other space */
	function linkFirstLoad() {
		//console.log(window.location.href);

		const mainnavLinks = Array.from(document.querySelectorAll('.col-right .nav a'));
		//links.push("http://localhost:9000");

		mainnavLinks.forEach(function(mainnavLink){
			var linkHref = mainnavLink.href;
			if(window.location.href.indexOf(mainnavLink.href) !== -1) {
				mainnavLink.classList.add('is-active');
			}
		});

        const bigmenuLinks = Array.from(document.querySelectorAll('.services-bigmenu a'));
		//links.push("http://localhost:9000");

		bigmenuLinks.forEach(function(bigmenuLink){
			var linkHref = bigmenuLink.href;
			if(window.location.href.indexOf(bigmenuLink.href) !== -1) {
				bigmenuLink.classList.add('is-active');
			}
		});

        const fixResponsive = document.querySelector('.responsive-fix');

        if (window.location.href.indexOf("propos") > -1 || window.location.href.indexOf("about") > -1) {
            fixResponsive.classList.add('is-active');
        } else {
            fixResponsive.classList.remove('is-active');
        }
	}
	linkFirstLoad();

    /* Delay for Ajax Step Timeline */
    function delay(n) {
        n = n || 2000;
        return new Promise((done) => {
            setTimeout(() => {
                done();
            }, n);
        });
    }
    
    /* Ajax */
    barba.hooks.before((data) => {
        bgTransition.style.transformOrigin = "bottom";

        if (!data.trigger.classList.contains("language-link")) {
            updateMainMenu(data.trigger.href);
        }
    
        updateBigMenu(data.trigger.href);
    });

    barba.hooks.after((data) => {
        //console.log('test');

        const cleanGSAP = () => {
            let existingScrollTriggers = ScrollTrigger.getAll();
            for (let index = 0; index < existingScrollTriggers.length; index++) {
                const singleTrigger = existingScrollTriggers[index];
                singleTrigger.kill(false);
            }
            ScrollTrigger.refresh();
            window.dispatchEvent(new Event("resize"));
            
            responsiveMenuTimeline.reverse(-1);
            headerShowHide();
            body.classList.remove('is-tiny');
            animedBtn();
            langSwitch();
            subservicesAccordion();
        };

        cleanGSAP();

        // 👉 Si le lien cliqué est dans #services-menu OU a la class --services-cta → scroll vers .service-img-container
        if (data.trigger && (data.trigger.closest('#services-menu') || data.trigger.matches('.--services-cta'))) {
            const target = document.querySelector('.service-img-container');
            if (target) {
                const offset = 200; // distance en pixels au-dessus du container
                const topPosition = target.getBoundingClientRect().top + window.scrollY - offset;
        
                window.scrollTo({
                    top: topPosition,
                    behavior: 'smooth'
                });
            }
            return; // empêche le scroll normal ou autre comportement
        }
        
        window.scrollTo(0, 0);
    });

    barba.init({
		preventRunning: true,
        sync: true,
        prevent: ({ el }) => el.classList && el.classList.contains('language-link'),

		transitions: [{
			name: 'main-transition',
			async beforeLeave(data) {
                gsap.fromTo(bgTransition, {
                    scaleY: 0
                },{
                    scaleY: 1, 
                    duration: .5,
                    ease: 'power4.inOut'
                });

                const currentMain = data.current.container.querySelector('.main-content');

                gsap.fromTo(currentMain, {
                    opacity: 1,
                    y:0,  
                },{
                    opacity: 0,
                    y:-20,
                    duration: .5,
                });

                if (body.classList.contains('menu-open')) {
                    body.classList.remove("body-fixed");
                    menuBtn.style.pointerEvents = "auto";
                    //menuBtn.style.marginRight = "0px";
                    body.classList.remove("menu-open");
                    menuTimeline.reverse();
                    //document.querySelector('header').classList.remove('is-tiny');
				}
			},
        
            async leave(data) {
                const done = this.async();
                await delay(800);
                done();
            },
    
			async enter(data) {		
                const currentMainAttribute = data.current.container.getAttribute('data-barba-namespace');
                const nextMainAttribute = data.next.container.getAttribute('data-barba-namespace');

                if (currentMainAttribute.indexOf("service") >= 0 && nextMainAttribute.indexOf("service") >= 0) { 
                    //console.log('yes');
                    mm.add("(min-width: 992px)", () => {
                        window.scrollTo(0, 525);
                    });

                    mm.add("(max-width: 991px)", () => {
                        //window.scrollTo(0, 0);
                        document.querySelector('.scroller').scrollTo(0, 0);
                    });
                } else {
                    mm.add("(min-width: 992px)", () => {
                        window.scrollTo(0, 0);
                    });

                    mm.add("(max-width: 991px)", () => {
                        //window.scrollTo(0, 0);
                        document.querySelector('.scroller').scrollTo(0, 0);
                    });
                }

                bgTransition.style.transformOrigin = "top";
			},

            
			async afterEnter(data) {
                initAccordion(data.next.container);
				const nextMain = data.next.container.querySelector('.main-content');

                var canvas = data.next.container.querySelector(".canvas");
                if (typeof(canvas) != 'undefined' && canvas != null) {
                    var ctx = canvas.getContext('2d');
                    var canvasContainer = data.next.container.querySelector(".canvas-container");
                    var canvasContainerHeight = canvasContainer.offsetHeight;
                }

                mm.add("(min-width: 1200px)", () => {
                    if (typeof(canvas) != 'undefined' && canvas != null) {
                        canvas.width = window.innerWidth;
                        canvas.height = canvasContainerHeight;

                        var stars = []; // Array that contains the stars
                        var FPS = 60; // Frames per second
                        var x = 100; // Number of stars

                        // Push stars to array
                        for (var i = 0; i < x; i++) {
                            stars.push({
                                x: Math.random() * canvas.width,
                                y: Math.random() * canvas.height,
                                radius: Math.random() * 1 + 1,
                                vx: Math.floor(Math.random() * 50) - 25,
                                vy: Math.floor(Math.random() * 50) - 25
                            });
                        }

                        // Draw the scene
                        function draw() {
                            ctx.clearRect(0,0,canvas.width,canvas.height);
                            
                            ctx.globalCompositeOperation = "lighter";
                            
                            for (var i = 0, x = stars.length; i < x; i++) {
                                var s = stars[i];
                            
                                ctx.fillStyle = "#e3e3e3";
                                ctx.beginPath();
                                ctx.arc(s.x, s.y, s.radius, 0, 2 * Math.PI);
                                ctx.fill();
                                ctx.fillStyle = 'black';
                                ctx.stroke();
                            }
                            
                            ctx.beginPath();
                            for (var i = 0, x = stars.length; i < x; i++) {
                                var starI = stars[i];
                                ctx.moveTo(starI.x,starI.y); 
                                for (var j = 0, x = stars.length; j < x; j++) {
                                    var starII = stars[j];
                                    if(distance(starI, starII) < 150) {
                                        //ctx.globalAlpha = (1 / 150 * distance(starI, starII).toFixed(1));
                                        ctx.lineTo(starII.x,starII.y); 
                                    }
                                }
                            }
                            ctx.lineWidth = 0.05;
                            ctx.strokeStyle = '#b1b1b1';
                            ctx.stroke();
                        }

                        function distance( point1, point2 ){
                            var xs = 0;
                            var ys = 0;
                            
                            xs = point2.x - point1.x;
                            xs = xs * xs;
                            
                            ys = point2.y - point1.y;
                            ys = ys * ys;
                            
                            return Math.sqrt( xs + ys );
                        }

                        // Update star locations
                        function update() {
                            for (var i = 0, x = stars.length; i < x; i++) {
                                var s = stars[i];
                            
                                s.x += s.vx / FPS;
                                s.y += s.vy / FPS;
                                
                                if (s.x < 0 || s.x > canvas.width) s.vx = -s.vx;
                                if (s.y < 0 || s.y > canvas.height) s.vy = -s.vy;
                            }
                        }

                        // Update and draw
                        function tick() {
                            draw();
                            update();
                            requestAnimationFrame(tick);
                        }

                        tick();
                    }
                });

                gsap.fromTo(bgTransition, {
                    scaleY: 1
                },{
                    scaleY: 0, 
                    duration: .5,
                    ease: 'power4.inOut'
                });

                gsap.fromTo(nextMain, {
                    opacity: 0,
                    y:20,
                    //ease: 'power4.inOut'
                },
                {  
                    y:0,
                    opacity: 1, 
                    duration: .5,
                    //delay: .5,
                });

			}
		}]
	});

    /* TEST CHAMP FORM */
    //console.log('tata');
    function checkProfilInputs() {
        const inputs = document.querySelectorAll('#edit-profil input');
        
        const allEmpty = [...inputs].every(input =>
            input.value.trim() === ""
        );
        
        if (allEmpty) {
            document.body.classList.add('profil-empty');
        } else {
            document.body.classList.remove('profil-empty');
        }
    }
      
    checkProfilInputs();
    //console.log('tata');

    // Sélectionne le formulaire
    const form = document.querySelector('#webform-submission-questionnaire-enneagramme-node-12-edit-form');

    // Vérifie si le formulaire existe
    if (form) {
        // Vérifie s'il n'y a aucun champ éditable
        const editableFields = form.querySelectorAll(
            'input:not([type="hidden"]):not([type="submit"]), textarea, select'
        );

        // Vérifie aussi la présence du message "n’est plus modifiable"
        const closedMessage = form.textContent.includes("n’est plus modifiable");

        if (editableFields.length === 0 || closedMessage) {
            document.body.classList.add('form-closed');
        } else {
            document.body.classList.remove('form-closed');
        }
    }

    const formFR = document.querySelector('#webform-submission-questionnaire-fr-node-17-edit-form');
    // Vérifie si le formulaire existe
    if (formFR) {
        // Vérifie s'il n'y a aucun champ éditable
        const editableFields = form.querySelectorAll(
            'input:not([type="hidden"]):not([type="submit"]), textarea, select'
        );

        // Vérifie aussi la présence du message "n’est plus modifiable"
        const closedMessage = form.textContent.includes("n’est plus modifiable");

        if (editableFields.length === 0 || closedMessage) {
            document.body.classList.add('form-closed');
        } else {
            document.body.classList.remove('form-closed');
        }
    }
});


(function (Drupal) {
    Drupal.behaviors.removeFieldsetErrorOnRadio = {
      attach(context) {
  
        const radios = context.querySelectorAll(
          'input[type="radio"]:not([data-once-remove-error])'
        );
  
        radios.forEach(radio => {
  
          // Simpler once() implementation
          radio.setAttribute('data-once-remove-error', 'true');
  
          radio.addEventListener('click', () => {
  
            // Fieldset principal contenant la classe error
            const mainFieldset = radio.closest('fieldset.radios--wrapper');
            if (mainFieldset) {
              mainFieldset.classList.remove('error');
              mainFieldset.removeAttribute('aria-invalid');
            }
  
            // Fieldset interne (celui du groupe de radios)
            const innerFieldset = radio.closest('fieldset');
            if (innerFieldset) {
              innerFieldset.classList.remove('error');
              innerFieldset.removeAttribute('aria-invalid');
            }
  
            // Enlever l'erreur sur tous les radios de ce groupe
            const groupContainer = radio.closest('.js-webform-radios');
            if (groupContainer) {
              groupContainer
                .querySelectorAll('input[type="radio"]')
                .forEach(r => {
                  r.classList.remove('error');
                  r.removeAttribute('aria-invalid');
                });
            }
  
            // Enlever l'erreur sur l'item (Drupal form-item)
            const formItem = radio.closest('.form-item');
            if (formItem) {
              formItem.classList.remove('error');
              formItem.classList.remove('form-item--error');
              formItem.removeAttribute('aria-invalid');
            }
          });
        });
      }
    };
    
})(Drupal);



/* Nouveau behavior pour les accordions + Barba */
(function (Drupal) {
  Drupal.behaviors.accordionBarba = {
    attach(context) {
      // Init accordions sur le DOM actuel ou injecté
      initAccordion(context);

      // Init Barba une seule fois
      if (!window.barbaInitDone) {
        window.barbaInitDone = true;

        //console.log("Initialisation Barba…");

        barba.init({
          transitions: [{
            async afterEnter(data) {
              console.log("afterEnter déclenché sur :", data.next.namespace);
              initAccordion(data.next.container);
            }
          }]
        });

        //console.log("Barba.init() appelé !");
      }
    }
  };
})(Drupal);